import { observable, makeObservable, action } from 'mobx';
import { getNoticeForceRead } from '@/api/notice';
import Toast from '@/components/Toast';

class ForceNotice {
    constructor() {
        makeObservable(this);
    }
    @observable noticeValue = {};

    @action setNoticeValue = (data) => {
        this.noticeValue = data;
    };

    // 判断是否强制阅读
    getForceNoticeDetail = async (param) => {
        const { code, msg, data } = await getNoticeForceRead(param);
        if (code === '00000') {
            this.setNoticeValue(data);
        } else {
            this.setNoticeValue({});
            Toast.error(msg);
        }
    };
}
export default new ForceNotice();
